
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SwipeableBox extends Vue {
  @Prop({ default: 0 }) index!: number;

  @Prop({ default: Infinity }) max!: number;

  @Prop({ default: false }) showArrows!: boolean | string;

  @Prop({ default: 1 }) step!: number;

  private touchstartX: number = 0;
  private touchstartY: number = 0;

  private touchendX: number = 0;
  private touchendY: number = 0;

  get canSwipeLeft() {
    return this.drawArrows && this.index > 0;
  }

  get canSwipeRight() {
    return this.drawArrows && this.index < this.max;
  }

  get drawArrows() {
    return this.showArrows !== false;
  }

  private swipeRight() {
    this.$emit('update:index', this.index + this.step);
    this.$emit('swipe-right');
  }

  private swipeLeft() {
    this.$emit('update:index', this.index - this.step);
    this.$emit('swipe-left');
  }

  private touchStart(event: TouchEvent) {
    this.touchstartX = event.changedTouches[0].screenX;
    this.touchstartY = event.changedTouches[0].screenY;
  }

  private touchEnd(event: TouchEvent) {
    this.touchendX = event.changedTouches[0].screenX;
    this.touchendY = event.changedTouches[0].screenY;
    this.handleGesture();
  }

  private handleGesture() {
    if (this.touchendX < this.touchstartX) {
      if (this.index + 1 <= this.max) {
        this.$emit('update:index', this.index + this.step);
      }
      this.$emit('swipe-left');
    }

    if (this.touchendX > this.touchstartX) {
      if (this.index - 1 >= 0) {
        this.$emit('update:index', this.index - this.step);
      }
      this.$emit('swipe-right');
    }

    if (this.touchendY < this.touchstartY) {
      this.$emit('swipe-up');
    }

    if (this.touchendY > this.touchstartY) {
      this.$emit('swipe-down');
    }

    if (this.touchendY === this.touchstartY) {
      this.$emit('tap');
    }
  }
}
